<template>
  <app-loading :active="$wait.is('app loading')"></app-loading>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { roundDecimalDigits } from '@/utils/currency'

export default {
  name: 'KPaymentCheckoutPage',
  components: {
    AppLoading: () => import('@/components/AppLoading.vue')
  },
  computed: {
    ...mapState('User', ['userProfile']),
    checkoutValue() {
      return JSON.parse(this.$utils.getKPaymentCheckout())
    }
  },
  created() {
    this.$wait.start('app loading')
  },
  async mounted() {
    const { token, saveCard } = this.$route.query

    if (!token) {
      this.$swal({
        title: 'มีบางอย่างผิดพลาด',
        text: 'กรุณาทดลองใหม่ หรือติดต่อเจ้าหน้าที่',
        icon: 'error'
      }).finally(() => {
        this.$router.push({ name: 'UploadSlipByOrderIdWithPayment',
          params: {
            orderId: this.checkoutValue._id,
            payment: 'byCreditCard'
          }
        })
      })
    }

    let customer

    if (this.userProfile?.kpayment) {
      customer = {
        customer_id: this.userProfile.kpayment?.customerId
      }
    }

    const response = await this.createCharge({
      amount: roundDecimalDigits(this.checkoutValue.netTotal),
      currency: 'THB',
      description: 'LINE By Sellsuki',
      source_type: 'card',
      mode: 'token',
      reference_order: this.checkoutValue._id,
      token,
      ref_1: this.checkoutValue.code,
      saveCard,
      customer
    }).catch(() => {
      this.$swal({
        title: 'มีบางอย่างผิดพลาด',
        text: 'กรุณาทดลองใหม่ หรือติดต่อเจ้าหน้าที่',
        icon: 'error'
      }).finally(() => {
        this.$router.push({ name: 'UploadSlipByOrderIdWithPayment',
          params: {
            orderId: this.checkoutValue._id,
            payment: 'byCreditCard'
          }
        })
      })
    })

    const {
      failure_code,
      failure_message,
      redirect_url,
      transaction_state,
      status,
      id
    } = response

    if (failure_code || failure_message) {
      this.$swal({
        text: this.$utils.vaildateErrorCode(failure_code),
        icon: 'error'
      }).finally(() => {
        this.$router.push({ name: 'UploadSlipByOrderIdWithPayment',
          params: {
            orderId: this.checkoutValue._id,
            payment: 'byCreditCard'
          }
        })
      })
    } else if (transaction_state === 'Pre-Authorized' && status === 'success') {
      if (saveCard === 'true') {
        this.$utils.setKPaymentUserSaveCard(JSON.stringify({
          email: this.checkoutValue.email,
          name: `${this.checkoutValue.firstName} ${this.checkoutValue.lastName}`,
          mode: 'token',
          token
        }))
      }

      this.$utils.setKPaymentChargeId(id)
      window.location.replace(redirect_url)
    } else {
      this.$swal({
        title: 'มีบางอย่างผิดพลาด',
        text: 'กรุณาทดลองใหม่ หรือติดต่อเจ้าหน้าที่',
        icon: 'error'
      }).finally(() => {
        this.$router.push({ name: 'UploadSlipByOrderIdWithPayment',
          params: {
            orderId: this.checkoutValue._id,
            payment: 'byCreditCard'
          }
        })
      })
    }
  },
  destroyed() {
    this.$wait.end('app loading')
  },
  methods: {
    ...mapActions({
      createCharge: 'Payment/createCharge'
    })
  }
}
</script>
